(function(){
  const countrySelects = document.querySelectorAll(".js-address-country select");
  const firstAddressFields = document.querySelectorAll("[name='address[address1]']");
  const secondAddressFields = document.querySelectorAll("[name='address[address2]']");
  const postCodeFieldInputs = document.querySelectorAll("[name='address[zip]']");

  countrySelects?.forEach((select) => {
    togglePhonePrefix(select);

    select.addEventListener("change", (event) => {
      togglePhonePrefix(event.currentTarget);
    });
  })

  firstAddressFields?.forEach((addressField) => {
    addressField.addEventListener('input', (event) => {
      if(event.currentTarget.value.length >= 40) {
        event.currentTarget.value = event.currentTarget.value.substr(0, 40);
      };
    });
  })

  secondAddressFields?.forEach((addressField) => {
    addressField.addEventListener("input", (event) => {
      if(event.currentTarget.value.length >= 10) {
        event.currentTarget.value = event.currentTarget.value.substr(0, 10);
      }
    });
  })

  postCodeFieldInputs?.forEach((postCodeField) => {
    postCodeField.addEventListener('input', (event) => {
      event.currentTarget.value = event.currentTarget.value.replace(/[^0-9]/g, '').substr(0, 5);
    });
  })

  function togglePhonePrefix(target) {
    const parentForm = target.closest("form");
    const phoneField = parentForm.querySelector("input[name='address[phone]']");

    if(target.selectedOptions[0].value === "Lithuania") {
      phoneField.value = "+370";
    }

    phoneField.addEventListener("input", phoneValidation);
  }

  function phoneValidation(event) {
    const rexExp = /(\d)/g,
          target = event.currentTarget;

    target.value = target.value.replaceAll("-", "").replaceAll(" ", "");

    if(target.value.length < 4) {
      target.value = "+370";
    } else {
      target.value = "+" + target.value.replace(/[^0-9]/g, '').substring(0, 11);
    }
  }
})();(function () {
  const sectionName = 'Text columns with images';
  const dataSection = 'text-columns';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${dataSection}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const scriptTag = section.querySelector('script');
        if(scriptTag) {
          scriptTag.remove();
        }
      }
    });
  } else {
    Shopify.theme.sections.register(sectionName);

    const allSections = document.querySelectorAll(".grid.grid--flush-bottom");

    allSections.forEach(sectionWithcards => {
      const cards = sectionWithcards.querySelectorAll(".grid__item");

      cards.forEach(card => {
        const popUp = card.querySelector(".pop-up");
        const closeButton = card.querySelector(".pop-up__close-button");

        card.addEventListener("click", function showPopUp() {
          popUp.classList.add("active");
        })

        closeButton.addEventListener("click", function hidePopUp(event) {
          popUp.classList.remove("active");
          event.stopPropagation();
        })
      })
    })
  }
}());const productBlockWidth = document.querySelector('.product-grid__container .product-block--login-message');
const paymnetButtonWithQuantity = document.querySelector('.product-grid__container .payment-button-with-quantity');


const mediaQuery = window.matchMedia("screen and (min-width: 769px)");
if (mediaQuery.matches && productBlockWidth && paymnetButtonWithQuantity) {
  paymnetButtonWithQuantity.style.width = +`${productBlockWidth.offsetWidth}` + 85 + 'px';
}const customer = document.querySelector('.customerOut');

if (customer) {
  const interval = setInterval(() => {
    const reviewButton = document.querySelector('.spr-summary-actions-newreview');

    if (reviewButton) {
      reviewButton.remove();
      clearInterval(interval);
    }
  }, 100);
}
(function () {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/apps/smart-seo/brokenLinks/add?page_url=' + window.location.pathname);

    xhr.onload = function () {
        if (xhr.status === 200) {            
        } else {
        }
    };

    xhr.send();
})();const discountPrices = document.querySelectorAll(".reduction-code__text");
discountPrices.forEach(price => {
  const valueWithoutBrackets = price.innerHTML.trim().replace('(','').replace(')', '');
  price.innerHTML = valueWithoutBrackets;
});
